import { render } from "./SectionArrow.vue?vue&type=template&id=43246c86&scoped=true"
import script from "./SectionArrow.vue?vue&type=script&lang=js"
export * from "./SectionArrow.vue?vue&type=script&lang=js"

import "./SectionArrow.vue?vue&type=style&index=0&id=43246c86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43246c86"]])

export default __exports__